import {UI} from "../../../../../stem-core/ui/UIBase";
import {DateCalendarInputInterface} from "../base/DateCalendarInputInterface";
import {DateCalendarMonthInput} from "./DateCalendarMonthInput";
import {StemDate} from "../../../../../stem-core/time/Date";


export class DateCalendarInput extends DateCalendarInputInterface {
    referenceTime = new StemDate();

    setValue(value) {
        super.setValue(value);
        this.referenceTime = value;
        this.swipe(this.referenceTime);
    }

    renderCalendarMonthComponent(monthDate) {
        const {minDate, maxDate} = this.options;

        return <DateCalendarMonthInput
            initialValue={this.value}
            className={this.styleSheet.month}
            onChange={value => this.setAndDispatchValue(value)}
            {...{minDate, maxDate, monthDate}}
        />;
    }
}
